module.exports = "<a ng-click=\"$ctrl.showDialog()\"\r\n   href=\"\"\r\n   translate>\r\n  Privacy Policy\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-privacy-policy/rw-privacy-policy.html
// module id = 1940
// module chunks = 0